import { createReducer, on } from '@ngrx/store';
import { BaseState, StateManager } from '@app/store/shared';
import { Reflection } from '../models';
import { reflectionActions } from '../actions/reflection.actions';
import { createKey } from '../utils/create-key';

export interface ReflectionState {
    items: Record<string, BaseState<Reflection>>;
    saving: boolean;
    saved: boolean | null;
}

const initialState: ReflectionState = {
    items: {},
    saving: false,
    saved: null,
};

export const reflectionReducer = createReducer(
    initialState,

    // Get Reflection
    on(reflectionActions.getReflection, (state, { id, params }): ReflectionState => {
        const key = createKey(id, params);
        const slice = state.items[key] ?? StateManager.initial<Reflection>();

        return {
            ...state,
            items: { ...state.items, [key]: StateManager.setLoadingInitOnly(slice) },
        };
    }),
    on(reflectionActions.getReflectionSuccess, (state, { id, params, payload }): ReflectionState => {
        const key = createKey(id, params);
        const slice = state.items[key] ?? StateManager.initial<Reflection>();

        return {
            ...state,
            items: { ...state.items, [key]: StateManager.setLoaded(slice, payload) },
        };
    }),
    on(reflectionActions.getReflectionNotAnswered, (state, { id, params }): ReflectionState => {
        const key = createKey(id, params);
        const slice = state.items[key] ?? StateManager.initial<Reflection>();

        return {
            ...state,
            items: { ...state.items, [key]: { ...slice, loading: false, loaded: true, data: null } },
        };
    }),
    on(reflectionActions.getReflectionError, (state, { id, params }): ReflectionState => {
        const key = createKey(id, params);
        const slice = state.items[key] ?? StateManager.initial<Reflection>();

        return {
            ...state,
            items: { ...state.items, [key]: StateManager.setError(slice) },
        };
    }),

    // Submit Reflection
    on(reflectionActions.submitReflection, (state): ReflectionState => ({
        ...state,
        saving: true,
        saved: null,
    })),
    on(reflectionActions.submitReflectionSuccess, (state, { id, params, payload }): ReflectionState => {
        const key = createKey(id, params);
        const slice = state.items[key] ?? StateManager.initial<Reflection>();

        return {
            ...state,
            saving: false,
            saved: true,
            items: { ...state.items, [key]: StateManager.setLoaded(slice, payload) },
        };
    }),
    on(reflectionActions.submitReflectionError, (state): ReflectionState => ({
        ...state,
        saving: false,
        saved: false,
    })),

    // Clear
    on(reflectionActions.clear, (): ReflectionState => initialState),
);
